import { Divider } from "@/atoms"
import { getPrProviderFromUrl } from "@/helpers/pr.helpers"
import { PullRequestOutlined, SourceControlIcon } from "@/icons"
import { TicketingSystemLogo } from "@/molecules/TicketingSystemLogo"
import { UNKNOWN_TICKET_SYSTEMS } from "./ActionCard.constants"

import styles from "./Action.module.scss"

import { ActionsCountComponent } from "."

export const ActionsCount: ActionsCountComponent = ({
  tickets,
  ticketSystems = UNKNOWN_TICKET_SYSTEMS,
  pullRequests
}) => {
  const hasPullRequests = pullRequests && pullRequests.length > 0
  const hasTickets = tickets && tickets.length > 0
  if (!hasTickets && !hasPullRequests) return null

  // Get unique providers from all PRs
  const providers = hasPullRequests
    ? [...new Set(pullRequests.map((pr) => getPrProviderFromUrl(pr.url)))]
    : []

  const showDivider = hasTickets && hasPullRequests

  return (
    <div className={styles.actionIcons}>
      {providers.map((provider, index) =>
        provider ? (
          <SourceControlIcon
            key={`${provider}-${index}`}
            sourceControl={provider}
            className={styles.icon}
            hideTooltip
          />
        ) : (
          <PullRequestOutlined
            key={`generic-${index}`}
            className={styles.icon}
          />
        )
      )}
      {showDivider && (
        <Divider orientation="vertical" className={styles.divider} />
      )}
      {hasTickets &&
        ticketSystems.map((system) => (
          <TicketingSystemLogo
            key={system}
            system={system}
            className={styles.icon}
          />
        ))}
    </div>
  )
}
